e.I.chart = {
	_drawChart : function(){
		var data = new google.visualization.DataTable();
		data.addColumn('string', 'Month');
		data.addColumn('number', 'Pageviews');
		data.addColumn('number', 'Pageviews');
		data.addColumn({type:'string', role:'annotation'});

		//Need to double up the data to create the red circles


		data.addRows([
			[page_views.three_months_ago.title, page_views.three_months_ago.count, page_views.three_months_ago.count, page_views.three_months_ago.title],

			[page_views.two_months_ago.title, page_views.two_months_ago.count, page_views.two_months_ago.count, page_views.two_months_ago.title],

			[page_views.last_month.title, page_views.last_month.count, page_views.last_month.count, page_views.last_month.title]
		]);


		var options = {
			title : null,
			backgroundColor : 'transparent',
			colors: ['#dadcdf', 'black'],
			dataOpacity: 1,
			legend : { position: 'none'},
			hAxis : {
				textStyle : { color : 'white' }
			},
			vAxis : {
				baselineColor : 'white',
				gridlines : { color : 'white' },
				textStyle : { color : 'white' }
			},
			//pointSize : 15,
			series: { //Create 2 separate series to fake what you want. One for the line             and one for the points
				0: {
					color: '#dadcdf',
					lineWidth: 2
				},
				1: {
					color: 'red',
					lineWidth: 0,
					pointSize: 15
				}
			},

			annotations: {
				boxStyle: {
					strokeWidth: 0,
					color: 'black'
				},
				textStyle: {
					fontName: 'Times-Roman',
					fontSize: 15,
					bold: true,
					italic: false,
					color: 'black',     // The color of the text.
					auraColor: 'transparent', // The color of the text outline.
					opacity: 1          // The transparency of the text.
				}
			}
		};

		var chart = new google.visualization.LineChart(document.getElementById('pageviews-chart'));
		chart.draw(data, options);
	}
};
if( typeof( google ) !== 'undefined' && typeof( google.load ) === 'function' && typeof( page_views ) !== 'undefined' ){
	google.load( "visualization", "1", {
		packages : ["corechart"]
	} );
	google.setOnLoadCallback( e.I.chart._drawChart );
}